<template>
  <footer>
    <section class="footer-call-to-action"><!-- footer call to action starts -->
      <section class="container">
        <div class="three-fourth">
<!--          <h4>If you you’re interested in working with Us, feel free to contact Us via contact form.</h4>-->
        </div>
        <div class="one-fifth">
<!--          <a href="#" class="button grey huge round">Purchase Now</a>-->
        </div>
      </section>
    </section><!-- footer call to action ends -->
    <footer id="footer" class="style-01"><!--footer starts -->
      <section class="container">
        <section class="three-fourth">
        <section class="one-third">
          <h4>{{$t('footer.aboutUs.title')}}</h4>
          <ul class="twitter-feeds">
            <!-- twitter widget starts-->
            <li><a href="javascript:" v-on:click="toAbout">{{$t('footer.aboutUs.tip1')}}</a></li>
            <li><a href="javascript:" v-on:click="toContact">{{$t('footer.aboutUs.tip2')}}</a></li>
          </ul>
          <!-- twitter widget ends-->
        </section>
        <section class="one-third">
          <h4>{{$t('footer.devType.title')}}</h4>
          <ul class="twitter-feeds">
            <!-- latest posts widget starts-->
            <li><a>{{$t('footer.devType.tip1')}}</a></li>
            <li><a>{{$t('footer.devType.tip2')}}</a></li>
            <li><a>{{$t('footer.devType.tip3')}}</a></li>
            <li><a>{{$t('footer.devType.tip4')}}</a></li>
            <li><a>{{$t('footer.devType.tip5')}}</a></li>
          </ul>
          <!-- lastest posts widget ends-->
        </section>
        <section class="one-third">
          <h4>{{$t('footer.case.title')}}</h4>
          <ul class="twitter-feeds">
            <!-- latest posts widget starts-->
            <li><a href="javascript:" v-on:click="toProductDisplay('xiaoyan')">{{$t('footer.case.tip1')}}</a></li>
            <li><a href="javascript:" v-on:click="toProductDisplay('anker')">{{$t('footer.case.tip2')}}</a></li>
            <li><a href="javascript:" v-on:click="toProductDisplay('Polaroid')">{{$t('footer.case.tip3')}}</a></li>
          </ul>
        </section>
      </section>
        <section class="one-fourth footer-logo">
          <div>
            <img src="static/img/headandfoot/logo.png" alt=""/><span>  </span>
          </div>
        </section>
      </section>
    </footer>
    <section id="copyrights">
      <section class="container">
        <div class="one" style="text-align: center">
          <p>
            Copyright &copy; 2020 cloudhearing All rights reserved. 云耳科技 保留所有权利。
          </p>
        </div>
      </section>
    </section>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    toAbout () {
      const router = this.$router
      // this.reload()
      // router.go(0)
      router.push({ name: 'aboutTeam' })
      // router.go(0)
      window.location.reload()
      window.scrollTo(0, 0)
    },
    toContact () {
      const router = this.$router
      // this.reload()
      // router.go(0)
      router.push({ name: 'contact' })
      // router.go(0)
      window.location.reload()
      window.scrollTo(0, 0)
    },
    toProductDisplay (data) {
      const router = this.$router
      // this.reload()
      // router.go(0)
      router.push({ name: 'product', params: {name: data} })
      // router.go(0)
      window.location.reload()
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped>
.footer-logo{
  margin-top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue